<template>
  <section class="project-five pt-130">
    <div class="section-header text-center">
      <h5 class="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s">{{$t('hzg74n')}}</h5>
      <h2 class="fadeInUp" data-wow-duration="1.4s" data-wow-delay=".4s">{{$t('bvwwfc')}}</h2>
    </div>
    
    <!-- 移除独立的轮播控制按钮区域 -->
    
    <!-- 解决方案轮播 -->
    <div class="container position-relative">
      <!-- 轮播控制按钮 -->
      <div class="project-nav-buttons">
        <button class="project-nav-btn project-nav-prev">
          <i class="fa-light fa-chevron-left"></i>
        </button>
        <button class="project-nav-btn project-nav-next">
          <i class="fa-light fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="swiper project__slider">
        <div class="swiper-wrapper">
          <!-- 使用 v-for 循环渲染解决方案项 -->
          <div class="swiper-slide" v-for="(solution, index) in pageListData" :key="index">
            <div class="project-card wow fadeInUp" data-wow-duration="1.2s" :data-wow-delay="`.${2 + index*2}s`">
              <!-- 上文部分 -->
              <div class="project-card__content p-5">
                <h3 class="text-xl font-bold mb-3">{{ solution.title }}</h3>
                <p class="mb-4 text-sm desc-text">{{ solution.desc }}</p>
                <NuxtLink :to="localePath(`/case/detail/${solution.pageId}`)" class="btn-one w-fit">
                  <span>了解更多</span> <i class="fa-solid fa-angles-right"></i>
                </NuxtLink>
              </div>
              <!-- 下图部分 -->
              <div class="project-card__image">
                <img :src="solution.avatar" class="w-full h-full object-cover" :alt="solution.title">
              </div>
            </div>
          </div>
        </div>
        
        <!-- 分页器 -->
        <div class="swiper-pagination project__pagination mt-6"></div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
const localePath = useLocalePath()
import { useI18n } from 'vue-i18n'
const { locale } = useI18n();

// 客户案例
const { data: pageList } = await useFetch<any>('/sre/pages/list/public', {
  baseURL: useRuntimeConfig().public.apiUrl,
  params: {
    classify: 'case',
    page: 1,
    size: 50,
  }
})
const pageListData = (pageList.value?.data?.list || []).map((v: any) => ({
  avatar: v.avatar[0],
  pageId: v.pageId,
  desc: v.desc[locale.value],
  title: v.title[locale.value],
}))

const solutionList = ref([])

// 初始化 Swiper
onMounted(() => {
  if (import.meta.client) {
    // 确保在客户端环境下执行
    const swiperEl = document.querySelector('.project__slider')
    if (!swiperEl) return

    const swiper = new Swiper('.project__slider', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.project__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.project-nav-next',
        prevEl: '.project-nav-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
  }
})
</script>

<style scoped>
.swiper-slide {
  padding: 15px 0;
}

.project-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  background-color: var(--bg-white);
}

.project-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.project-card__content {
  flex: 0 0 auto;
}

.desc-text {
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.project-card__image {
  flex: 1 0 auto;
  height: 280px;
  overflow: hidden;
  position: relative;
}

.project-card__image img {
  transition: transform 0.5s ease;
}

.project-card:hover .project-card__image img {
  transform: scale(1.05);
}

/* 轮播导航按钮样式 */
.project-nav-buttons {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 10;
  pointer-events: none;
  display: flex;
  justify-content: space-between;
  padding: 0 -10px;
}

.project-nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: none;
  outline: none;
  transition: all 0.3s ease;
  pointer-events: auto;
  color: var(--primary-color, #333);
  font-size: 14px;
}

.project-nav-btn:hover {
  background-color: var(--primary-color, #333);
  color: white;
}

.project-nav-prev {
  margin-left: -20px;
}

.project-nav-next {
  margin-right: -20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .project-card__image {
    height: 220px;
  }
  
  .project-nav-buttons {
    padding: 0;
  }
  
  .project-nav-btn {
    width: 36px;
    height: 36px;
    font-size: 12px;
  }
  
  .project-nav-prev {
    margin-left: 5px;
  }
  
  .project-nav-next {
    margin-right: 5px;
  }
}

@media (max-width: 576px) {
  .project-card__content {
    padding: 15px;
  }
  
  .project-card__image {
    height: 180px;
  }
  
  .project-nav-btn {
    width: 32px;
    height: 32px;
  }
}
</style>
